import { useContext } from "react";
import { AppContext } from "../store";

const useIsLoading = () => {
    const { state } = useContext(AppContext);
    return !!state.orgInfo?.loading;
}

export default useIsLoading;